module.exports = __webpack_public_path__ + "3dabd4af277b38d533b4f8fb62f3927c.svg";